var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489 489",
    style: {
      enableBackground: "new 0 0 489 489"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.5,0C109.2,0,0,109.3,0,244.5S109.2,489,244.5,489C379.7,489,489,379.7,489,244.5S379.7,0,244.5,0z M429.6,329.8h-78.3 c3.3-20.2,5.4-41.8,6.2-64.5h89.8C445,288.1,438.9,309.8,429.6,329.8z M244.5,448.4c-18.1,0-40.6-27.6-55.8-77h111.6 C285.1,420.8,262.5,448.4,244.5,448.4z M178.8,329.8c-3.5-19.4-5.8-41-6.7-64.5H317c-0.9,23.5-3.3,45.1-6.7,64.5H178.8z  M59.8,158.2h78c-3.4,20.5-5.6,42.5-6.4,65.5H41.6C44,200.5,50.3,178.4,59.8,158.2z M244.5,40.6c17.9,0,40.3,27.2,55.5,75.9H189 C204.2,67.8,226.5,40.6,244.5,40.6z M310,158.2c3.6,19.7,6,41.6,6.9,65.5H172.1c0.9-23.9,3.3-45.8,6.9-65.5H310z M41.6,265.3h89.8 c0.8,22.7,2.9,44.3,6.2,64.5H59.3C50.1,309.8,44,288.1,41.6,265.3z M357.5,223.7c-0.8-23.1-3-45-6.4-65.5h78 c9.5,20.3,15.8,42.3,18.2,65.5H357.5z M403.1,116.5h-61c-6.6-24-15-45.1-25-62.5C351,67,380.6,88.8,403.1,116.5z M171.8,54 c-9.9,17.4-18.4,38.5-25,62.5h-61C108.4,88.8,137.9,67,171.8,54z M85.1,371.4h61.5c6.6,24.4,15.2,45.9,25.2,63.6 C137.5,421.8,107.6,399.7,85.1,371.4z M317.1,435c10.1-17.7,18.6-39.1,25.2-63.6h61.5C381.3,399.7,351.4,421.8,317.1,435z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ec90e8a2206d686d37bbcde237b53176.svg";
export { ForwardRef as ReactComponent };